import { useEffect } from "react";
import { useTranslation } from "react-i18next";

import InputAutocomplete from "../../atoms/InputAutocomplete/InputAutocomplete";
import { QuestionProps } from "../../../types/components/molecules/questionProps";
import { useFilteredBreeds } from "../../../helpers/useFilteredBreeds";

const Sixth = ({ formData, setFormData, onValidationChange }: QuestionProps) => {
  const { t } = useTranslation();

  useEffect(() => {
    onValidationChange?.(!!formData.breed_id);
  }, [formData.breed_id, onValidationChange]);

  const { breedsOptions, getBreedData } = useFilteredBreeds(formData.species);
  const { option: selectedOption } = getBreedData(formData.breed_id);

  return (
    <InputAutocomplete
      label={t("animalInfo:QUESTION_SIX.RACE")}
      value={selectedOption}
      options={breedsOptions}
      onChange={(_event, value) => {
        setFormData({
          ...formData,
          breed_id: value?.value,
        });
      }}
    />
  );
};

export default Sixth;
